<router-outlet />
<app-loader 
  [loading]="loaderService.isLoading()" 
  [message]="loaderService.loadingMessage()"
  [fullScreen]="true"
  [backdrop]="true">
</app-loader>
